import { defaultTheme } from 'constants/theme/defaultTheme';
import styled from 'styled-components';
import { breakpoints } from 'stylesheet';

export const Styles = {
  Wrapper: styled.div`
    width: 100%;
    margin-top: ${defaultTheme.spacing(8)};
    @media (max-width: ${breakpoints.small}) {
      margin-top: ${defaultTheme.spacing(4)};
      padding: ${defaultTheme.spacing(4)};
    }
  `,
  Link: styled.button`
    font-family: ${defaultTheme.fontFamily};
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
    color: ${defaultTheme.colors.healthBlue};
    cursor: pointer;
    background-color: transparent;
    border: none;
    padding: 0;
  `,
  SmallLink: styled.a`
    font-family: ${defaultTheme.fontFamily};
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: ${defaultTheme.colors.healthBlue};
  `,
  Line: styled.div`
    width: 100%;
    height: 1px;
    background-color: ${defaultTheme.colors.separator};
    margin: ${defaultTheme.spacing(4)} 0;
  `,
};
